import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY, FACILITY_KEY } from "utils/customNameHelpers"
import { getFacilityAndDepartmentFromDepartmentId } from "reduxSlices/facilitiesSlice"

const formattedAnswer = (facility, department, facilityName, departmentName) => {
  if (!facility && !department) return null

  return (
    <>
      <span className="block mb-4">
        {facilityName}:<br />{facility?.name}
      </span>
      <span className="block">
        {departmentName}:<br />{department?.name}
      </span>
    </>
  )
}

const LocationAnswer = ({ rawAnswer = undefined, isNewQuestion = false }) => {
  const [facility, department] = useSelector(getFacilityAndDepartmentFromDepartmentId(rawAnswer?.department_id))

  const { name: facilityName } = useCustomName(FACILITY_KEY)
  const { name: departmentName } = useCustomName(DEPARTMENT_KEY)

  if (isNewQuestion) return null

  return (
    <div className="answer screenreader-whitespace">
      { formattedAnswer(facility, department, facilityName, departmentName) }
    </div>
  )
}

LocationAnswer.propTypes = {
  rawAnswer: types.shape({ department_id: types.number }),
  isNewQuestion: types.bool,
}

export default LocationAnswer
